import { CatalogPhaseEventsPage } from "./CatalogPhaseEvents";
import { CatalogPhaseEventsProvider } from "./CatalogPhaseEventsContext";

const CatalogPhaseEvents = () => {
	return (
		<CatalogPhaseEventsProvider>
			<CatalogPhaseEventsPage />
		</CatalogPhaseEventsProvider>
	);
};

export default CatalogPhaseEvents;
